import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import './App.scss';
import Dashboard from './components/dashboard/Dashboard';
import UsersGroups from './components/usersgroup/UsersGroups';
import HelpIndex from './components/help/HelpIndex';
import FaqsPage from './components/help/FaqsPage';
import VideoTutorials from './components/help/VideosTutorials';
import Tasks from './components/Tasks';
import Login from './components/user/Login';
import FirstLogin from './components/user/FirstLogin';
import EditTask from './components/tasks/EditTask';
import PreviewTask from './components/tasks/PreviewTask';
import TaskSite from './components/tasks/TaskSite';
import Users from './components/admin/users/Users';
import Helps from './components/admin/help/Helps';
import Faqs from './components/admin/faq/Faqs';
import Feedbacks from './components/admin/feedback/Feedbacks';
import Orgs from './components/admin/org/Orgs';
import TaskExamples from './components/admin/examples/TaskExamples';
import Videos from './components/admin/video/Videos';
import ExportUsers from './components/admin/export/ExportUsers';
import { registerEventEnd, registerEventStart } from './utils/utils';
import ExportUserEvents from './components/admin/export/ExportUserEvents';
import ExportTasks from './components/admin/export/ExportTasks';
import ExportNlpEvents from './components/admin/export/ExportNlpEvents';
import DoShareTask from './components/tasks/DoShareTask';
import ResetPassword from './components/user/ResetPassword';
import { useTranslation } from 'react-i18next';
import i18n from './i18n/config';
import VersionNotification from './components/elements/VersionNotification';
import Notifications from './components/elements/Notifications';

const APP_VERSION = "0.4.1";

function TaskGenRoutes() {
  const { t } = useTranslation();
  
  const location = useLocation();

  const [curRoute, setCurRoute] = useState('/');
  const [eventId, setEventId] = useState('');

  useEffect(() => {
    // Track path changes
    if (location.pathname.includes('/edit-task/')) {
      registerEventStart('edit task', '').then(data => {
        setEventId(data);
      });
    }
    if (curRoute.includes('/edit-task/') && !location.pathname.includes('/edit-task/') && eventId.length > 0) {
      registerEventEnd(eventId);
    }
    
    if (location.pathname.includes('/help')) {
      registerEventStart('help', '').then(data => {
        setEventId(data);
      });
    }
    if (curRoute.includes('/help') && !location.pathname.includes('/help') && eventId.length > 0) {
      registerEventEnd(eventId);
    }
    
    setCurRoute(location.pathname);

    const currentLanguage = localStorage.getItem('taskgen_interface_language') ?? 'en';
    i18n.changeLanguage(currentLanguage);
  
  }, [location]);

  return(
    <Routes>
      <Route path="/" element={<Login />}></Route>
      <Route path="/dashboard" element={<Dashboard name="John Doe"/>}></Route>
      <Route path="/users-groups" element={<UsersGroups />}></Route>
      <Route path="/help" element={<HelpIndex />}></Route>
      <Route path="/faqs" element={<FaqsPage />}></Route>
      <Route path="/video-tutorials" element={<VideoTutorials />}></Route>
      <Route path='/first-login' element={<FirstLogin />}></Route>
      <Route path="/tasks" element={< Tasks />}></Route>
      <Route path="/edit-task/:id" element={<EditTask />}></Route>
      <Route path="/preview-task/:id" element={<PreviewTask />}></Route>
      <Route path="/task-site/:id/:mode" element={<TaskSite />}></Route>
      <Route path="/admin/users" element={<Users />}></Route>
      <Route path="/admin/help" element={<Helps />}></Route>
      <Route path="/admin/faqs" element={<Faqs />}></Route>
      <Route path="/admin/feedbacks" element={<Feedbacks />}></Route>
      <Route path="/admin/orgs" element={<Orgs />}></Route>
      <Route path="/admin/taskexamples" element={<TaskExamples />}></Route>
      <Route path="/admin/videos" element={<Videos />}></Route>
      <Route path="/admin/export/users" element={<ExportUsers />}></Route>
      <Route path="/admin/export/user-events" element={<ExportUserEvents />}></Route>
      <Route path="/admin/export/tasks" element={<ExportTasks />}></Route>
      <Route path="/admin/export/nlp-events" element={<ExportNlpEvents />}></Route>
      <Route path="/do-share/:id" element={<DoShareTask />}></Route>
      <Route path="/reset-password/:token" element={<ResetPassword />}></Route>
    </Routes>
  )
}

function App() {
  return (
    <Router>
      <div className="app">
        <Notifications />
        <VersionNotification />
        <TaskGenRoutes />
        <div className="app-version">
          v{APP_VERSION}
        </div>
      </div>
    </Router>);
}

export default App;
